// extracted by mini-css-extract-plugin
export default {"root":"PrivacyPolicy_root__Vr+vU","lastUpdated":"PrivacyPolicy_lastUpdated__HURRV","listTitle":"PrivacyPolicy_listTitle__MtQc6"};